// this is an autogenerated file from DesignSystem/CheckIn/query_check_in_settings.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CheckIn($current_location_id: uuid!) {
  vaxiom_location_access_keys(
    where: {
      organization: { _id: { _eq: $current_location_id } }
      access_name: { _eq: "PATIENT_CHECKIN" }
    }
  ) {
    id
    settings {
      id: location_access_key_id
      max_minutes_late
      max_due_amount
      due_period
      max_due_amount_insurance
      due_period_insurance
    }
  }
}

`